import { EventEmitter, Injectable } from "@angular/core";
import { ControlComponentAdaptor } from "./control-component-adaptor";

@Injectable()
export class FieldWrapperKeyboardController {

    exitBackwards: EventEmitter<KeyboardEvent> = new EventEmitter<KeyboardEvent>();
    exitForwards: EventEmitter<KeyboardEvent> = new EventEmitter<KeyboardEvent>();

    handleTabEvent($event: KeyboardEvent, shift: boolean = false, controlComponentAdaptor: ControlComponentAdaptor): boolean {

        const targetElem = $event.target;
        const tabbables = controlComponentAdaptor.getTabbableElements();

        // are we exiting backwards?
        if (targetElem === tabbables[0] && shift) {
            this.exitBackwards.next($event);
            if ($event.defaultPrevented) {
                return false;
            }
        }

        // are we exiting forwards?
        if (targetElem === tabbables[tabbables.length - 1] && !shift) {
            this.exitForwards.next($event);
            if ($event.defaultPrevented) {
                return false;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-shared/field-wrapper/field-wrapper-keyboard.controller.ts